import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';

import IMG_HUNT_GROUPS_MULTIPLE from 'images/wallboard/hunt_groups_multiple.png';
import IMG_TEAM_CUSTOM from 'images/wallboard/team_custom.png';

interface Props {
    boardType: 'hunt_groups_multiple' | 'team_custom';
}

const DashboardHeader = ({ boardType }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex justify-between">
            <p className="flex flex-col gap-2">
                <span className="text-lg">
                    {i18next.t(`wallboard.title.${boardType}`)}
                </span>
                <span className="text-sm">
                    {i18next.t(`wallboard.description.${boardType}`)}
                </span>
            </p>
            <img
                src={
                    boardType === 'hunt_groups_multiple'
                        ? IMG_HUNT_GROUPS_MULTIPLE
                        : IMG_TEAM_CUSTOM
                }
                alt={i18next.t(`wallboard.title.${boardType}`)}
            />
        </div>
    );
};

export default DashboardHeader;
